import { getHash } from '@/helpers/math'
import Field from '@/components/_shared/Field.vue'
import SubmitButton from '@/components/_shared/SubmitButton.vue'
import validateFormMixin from '@/mixins/validate-form'
import LoginFormMethods from './LoginForm-methods'

export default {
  name: 'LoginForm',
  components: {
    Field,
    SubmitButton,
  },
  mixins: [validateFormMixin, LoginFormMethods],

  data() {
    return {
      formData: {
        email: '',
        password: '',
        password_confirmation: '',
        remember_me: 1,
      },
      helperCheckbox: false,
      hash: getHash(),
    }
  },

  props: {
    paths: {
      type: Object,
      required: true,
    },
    actionType: {
      type: String,
      default: 'login',
      validator(value) {
        return ['login', 'signUp'].indexOf(value) >= 0
      },
    },
    variant: {
      type: String,
      default: 'account',
      validator(value) {
        return ['checkout', 'account', 'navigation'].indexOf(value) >= 0
      },
    },
    emailProp: String,
    preventFormSubmit: Boolean,
  },

  watch: {
    actionType() {
      this.resetForm()
    },

    helperCheckbox(value) {
      this.resetRememberMeFlag(value)
    },

    isDesktopViewport() {
      this.resetShowPassword()
      this.resetRememberMeFlag(false)
    },

    'formData.email': function(email) {
      if (this.variant == 'checkout') On.LocalStorage.set('checkoutRegistrationEmail', email)
    },

    emailProp(email) {
      this.$set(this.formData, 'email', email)
    },
  },

  computed: {
    isDesktopViewport() {
      return this.$store.state.viewport.width >= On.MediaQueries.width.large
    },

    helperCheckboxId() {
      return `helper-checkbox-${this.hash}`
    },

    labelOfHelperCheckbox() {
      if (this.actionType == 'login') {
        return this.isDesktopViewport
          ? this.$t('checkout.login.remember_me')
          : this.$t('checkout.login.show_password')
      } else {
        return this.$t('checkout.newsletter_checkbox_prompt')
      }
    },

    submitButtonText() {
      const localeKey = this.actionType == 'login' ? 'login' : 'sign_up'
      return this.$t(`checkout.login.${localeKey}`)
    },

    shouldDisplayForgotPasswordLink() {
      return this.actionType == 'login' && this.variant != 'navigation'
    },

    csrfToken() {
      const meta = document.querySelector('meta[name="csrf-token"]')
      return meta ? meta.getAttribute('content') : ''
    },

    newsletterSubscribed() {
      return this.actionType != 'login' && this.helperCheckbox
    },

    permittedFields() {
      const fields = ['email', 'password', 'remember_me']

      if (this.actionType == 'signUp') {
        fields.push('password_confirmation')
      }
      return fields
    },

    submitCtaModifiers() {
      switch (this.variant) {
        case 'checkout':
          return ['button', 'blue', 'neutraface']
        case 'account':
          return ['button', 'blue', 'neutraface']
        case 'navigation':
          return ['button', 'primary']
      }
    },
  },

  mounted() {
    this.resetForm()
  },
}
